import script from "./HistoryChat.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryChat.vue?vue&type=script&setup=true&lang=js"

import "./HistoryChat.vue?vue&type=style&index=0&id=053a43bc&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053a43bc"]])

export default __exports__